export const version = {
    major: 4,
    minor: 4,
    patch: 3,
};
